const $contactForm = $(".js-contact-form form");

$contactForm.on("submit", function (e) {
  let $form = $(this);
  let $requiredField = $form.find(".field-required");
  let preventSubmit = false;
  let $email = $("#contact-email");
  let emailVal = $email.val();
  let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

  // check if all fields are filled in
  $requiredField.each(function () {
    const $field = $(this);

    if ($field.attr("type") === "checkbox") {
      if ($field.get(0).checked === false) {
        preventSubmit = true;
        $field.addClass("checkbox-error");
      } else {
        $field.removeClass("checkbox-error");
      }
    } else {
      const fieldVal = $field.val();

      if (fieldVal === "") {
        preventSubmit = true;
        $field.addClass("is-empty");
      } else {
        $field.removeClass("is-empty");
      }
    }
  });

  // if the email is not valid
  if (!emailRegex.test(emailVal)) {
    $email.addClass("is-empty");
    preventSubmit = true;
  }

  // prevent from submitting if klaviyo is not submitted or there is empty value
  if (preventSubmit || $form.hasClass("prevent-submit")) {
    e.preventDefault();
  }

  // trigger submit to klaviyo
  if (!preventSubmit && $form.hasClass("prevent-submit")) {
    submitToKlaviyo(emailVal);
  }
});

$contactForm
  .find('input.field-required:not(input[type="checkbox"])')
  .on("keyup", function () {
    if ($(this).val() !== "") {
      $(this).removeClass("is-empty");
    } else {
      $(this).addClass("is-empty");
    }
  });

function submitToKlaviyo(emailVal) {
  let encodeEmail = encodeURIComponent(emailVal);
  $.ajax({
    url: "https://a.klaviyo.com/ajax/subscriptions/subscribe",
    type: "POST",
    data: `g=${window.listID}&email=${encodeEmail}`,
  }).done(() => {
    $(".js-contact-form form").removeClass("prevent-submit");

    $(".js-contact-form form").trigger("submit");
  });
}
